module.exports = __webpack_public_path__ + "static/devops-830b1436d0ecd9f52fcc231ba1164768.png";